export const validateEmail = (email) => {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return re.test(String(email).toLowerCase());
}

export const validateModeloCar = (e) => {
	const characters = ["-"];			
	  if (characters.indexOf(e.key) === -1 && !/^[0-9a-zA-Z]+$/.test(e.key)) {
		e.preventDefault();
		return;
}}
export const validatePatenteCar = (e) => {
	  if ( !/^[0-9a-zA-Z]+$/.test(e.key)) {
		e.preventDefault();
		return;
}}

export const formatDate = (date, format)=>{
	const dateType = date?(new Date(date)):(new Date());
	const mes = dateType.getMonth() + 1;
	const dia = dateType.getDate();
	const map = {
	  mm: mes<10?mes.toString().padStart(2,'0'):mes,
		dd: dia<10?dia.toString().padStart(2,'0'):dia,
		yyyy: dateType.getFullYear()
	};
	return format.replace(/mm|dd|yyyy/gi, matched => map[matched]);
  }
export const validatePhone = (phone) => {
    const re = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{3})$/;
    return re.test(String(phone).toLowerCase());
}

export const validateRut = obj => {
	var largo, crut, rut, dv, i, suma, mul, res, dvi;
	var tmpstr = '';
	var intlargo = obj;
	if (intlargo.length > 0) {
		crut = obj;
		largo = crut.length;
		if (largo < 2) {
			return false;
		}
		for (i = 0; i < crut.length; i++)
			if (crut.charAt(i) !== ' ' && crut.charAt(i) !== '.' && crut.charAt(i) !== '-') {
				tmpstr = tmpstr + crut.charAt(i);
			}
		rut = tmpstr;
		crut = tmpstr;
		largo = crut.length;
		if (largo > 2) rut = crut.substring(0, largo - 1);
		else rut = crut.charAt(0);
		dv = crut.charAt(largo - 1);
		if (rut == null || dv == null) return 0;
		var dvr = '0';
		suma = 0;
		mul = 2;
		for (i = rut.length - 1; i >= 0; i--) {
			suma = suma + rut.charAt(i) * mul;
			if (mul === 7) mul = 2;
			else mul++;
		}
		res = suma % 11;
		if (res === 1) dvr = 'k';
		else if (res === 0) dvr = '0';
		else {
			dvi = 11 - res;
			dvr = dvi + '';
		}
		if (dvr !== dv.toLowerCase()) {
			return false;
		}
		return true;
	}
};